"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DraftTabFilterCases = exports.ExternalTabFilterCases = exports.InternalTabFilterCases = exports.ClaimInternalFields = exports.ClaimExternalFields = void 0;
var utils_1 = require("@hobt/utils");
var constants_1 = require("../constants");
var claim_fields_1 = require("./claim-fields");
exports.ClaimExternalFields = [
    claim_fields_1.ClaimFieldNames.claimID,
    claim_fields_1.ClaimFieldNames.approvedLenderCode,
    claim_fields_1.ClaimFieldNames.approvedLenderEnglishName,
    claim_fields_1.ClaimFieldNames.approvedLenderFrenchName,
    claim_fields_1.ClaimFieldNames.approvedLenderReferenceNumber,
    claim_fields_1.ClaimFieldNames.approvedLenderTransitNumber,
    claim_fields_1.ClaimFieldNames.claimTypeCode,
    claim_fields_1.ClaimFieldNames.claimTypeIndicator,
    claim_fields_1.ClaimFieldNames.cmhcLoanAccountNumber,
    claim_fields_1.ClaimFieldNames.correspondenceLanguage,
    claim_fields_1.ClaimFieldNames.claimStatus,
    claim_fields_1.ClaimFieldNames.primaryBorrowerFirstName,
    claim_fields_1.ClaimFieldNames.primaryBorrowerLastName,
    claim_fields_1.ClaimFieldNames.recordCreatedTimestamp,
    claim_fields_1.ClaimFieldNames.recordCreatedUserID,
    claim_fields_1.ClaimFieldNames.recordUpdatedTimestamp,
    claim_fields_1.ClaimFieldNames.recordUpdatedUserID,
    claim_fields_1.ClaimFieldNames.recordUpdatedUserFullName,
    claim_fields_1.ClaimFieldNames.newInternalAttachmentFlag,
    claim_fields_1.ClaimFieldNames.newInternalCommentFlag,
];
exports.ClaimInternalFields = [
    claim_fields_1.ClaimFieldNames.claimID,
    claim_fields_1.ClaimFieldNames.approvedLenderCode,
    claim_fields_1.ClaimFieldNames.approvedLenderEnglishName,
    claim_fields_1.ClaimFieldNames.approvedLenderFrenchName,
    claim_fields_1.ClaimFieldNames.approvedLenderReferenceNumber,
    claim_fields_1.ClaimFieldNames.approvedLenderTransitNumber,
    claim_fields_1.ClaimFieldNames.claimTypeCode,
    claim_fields_1.ClaimFieldNames.claimTypeIndicator,
    claim_fields_1.ClaimFieldNames.cmhcLoanAccountNumber,
    claim_fields_1.ClaimFieldNames.correspondenceLanguage,
    claim_fields_1.ClaimFieldNames.claimStatus,
    claim_fields_1.ClaimFieldNames.primaryBorrowerFirstName,
    claim_fields_1.ClaimFieldNames.primaryBorrowerLastName,
    claim_fields_1.ClaimFieldNames.recordCreatedTimestamp,
    claim_fields_1.ClaimFieldNames.recordCreatedUserID,
    claim_fields_1.ClaimFieldNames.recordUpdatedTimestamp,
    claim_fields_1.ClaimFieldNames.recordUpdatedUserID,
    claim_fields_1.ClaimFieldNames.recordUpdatedUserFullName,
    claim_fields_1.ClaimFieldNames.ownerFullName,
    claim_fields_1.ClaimFieldNames.newExternalAttachmentFlag,
    claim_fields_1.ClaimFieldNames.newExternalCommentFlag,
];
var ClaimInternalFieldsKey = utils_1.reduce(exports.ClaimInternalFields);
var ClaimExternalFieldsKey = utils_1.reduce(exports.ClaimExternalFields);
exports.InternalTabFilterCases = new Map([
    ['all', ''],
    [
        'unassigned',
        "ClaimStatusCode IN (" + constants_1.InternalClaimStatus.New + ", \n      " + constants_1.InternalClaimStatus.ReviewRequired + ", \n      " + constants_1.InternalClaimStatus.Pending + ")\n    AND AdjudicatorUserID IS NULL",
    ],
    [
        'inReview',
        "ClaimStatusCode IN (" + constants_1.InternalClaimStatus.InProgress + ",\n      " + constants_1.InternalClaimStatus.Pending + ",\n      " + constants_1.InternalClaimStatus.ReviewRequired + ",\n      " + constants_1.InternalClaimStatus.ApprovalRequired + ")",
    ],
    [
        'approved',
        "ClaimStatusCode IN (" + constants_1.InternalClaimStatus.ApprovedAuto + ",\n      " + constants_1.InternalClaimStatus.ApprovedManual + ",\n      " + constants_1.InternalClaimStatus.ClaimPaymentInProgress + ",\n      " + constants_1.InternalClaimStatus.PaymentFailed + ",\n      " + constants_1.InternalClaimStatus.NoClaimPayable + ",\n      " + constants_1.InternalClaimStatus.Paid + ",\n      " + constants_1.InternalClaimStatus.RefundRequested + ",\n      " + constants_1.InternalClaimStatus.CmhcReimbursed + ")",
    ],
    [
        'declinedCancelled',
        "ClaimStatusCode IN (" + constants_1.InternalClaimStatus.Declined + ",\n      " + constants_1.InternalClaimStatus.Cancelled + ")",
    ],
    ['approvalRequired', "ClaimStatusCode=" + constants_1.InternalClaimStatus.ApprovalRequired],
]);
exports.ExternalTabFilterCases = new Map([
    ['all', ''],
    [
        'inProgress',
        "ClaimStatusCode IN (" + constants_1.InternalClaimStatus.New + ",\n      " + constants_1.InternalClaimStatus.ReviewRequired + ",\n      " + constants_1.InternalClaimStatus.InProgress + ",\n      " + constants_1.InternalClaimStatus.Pending + ",\n      " + constants_1.InternalClaimStatus.ApprovalRequired + ")",
    ],
    [
        'declinedCancelled',
        "ClaimStatusCode IN (" + constants_1.InternalClaimStatus.Cancelled + ",\n      " + constants_1.InternalClaimStatus.Declined + ")",
    ],
    [
        'approved',
        "ClaimStatusCode IN (" + constants_1.InternalClaimStatus.Paid + ",\n      " + constants_1.InternalClaimStatus.ApprovedAuto + ",\n      " + constants_1.InternalClaimStatus.ApprovedManual + ",\n      " + constants_1.InternalClaimStatus.ClaimPaymentInProgress + ",\n      " + constants_1.InternalClaimStatus.PaymentFailed + ",\n      " + constants_1.InternalClaimStatus.NoClaimPayable + ")",
    ],
    [
        'refundRequests',
        "ClaimStatusCode IN (" + constants_1.InternalClaimStatus.CmhcReimbursed + ",\n      " + constants_1.InternalClaimStatus.RefundRequested + ")",
    ],
]);
exports.DraftTabFilterCases = new Map([
    ['activeDrafts', "StatusCode=" + constants_1.DraftClaimStatus.InDraft],
    ['processInMics', "StatusCode=" + constants_1.DraftClaimStatus.ProcessInMics],
]);
